import {
  Toolbar,
  Typography,
  Button,
  makeStyles,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Drawer,
  Modal,
  Box,
  Paper,
  CircularProgress,
  Tooltip,
} from "@material-ui/core";
import { Fragment } from "react";
import ActivitiesPage from "./pages/ActivitiesPage";
import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { useAlert } from "react-alert";
import { useConfirm } from "material-ui-confirm";
import BranchesPage from "./pages/BranchesPage";
import NavigationComponent from "./components/NavigationComponent";
import AdminCreateProvider from "./components/AdminCreateProvider";
import HelpPage from "./pages/HelpPage";
import { useEffect, useState } from "react";
import EmailIcon from "@material-ui/icons/Email";
import {
  fetchProviderInfo,
  deleteProviderInfo,
  validateProvider,
} from "./api/providerInfo";
import { format } from "date-fns";
import { getCategories, fetchCategoryTree } from "./api/categories";
import {
  Edit,
  Label,
  Note,
  Phone,
  Place,
  Send,
  Today,
} from "@material-ui/icons";
import { sendActionEmail } from "./api/admin";
import HeaderBar from "./components/HeaderBar";
import AddProviderInfo from "./components/AddProviderInfo";
import OverviewPage from "./pages/OverviewPage";
import ProviderListPage from "./pages/ProviderListPage";
import { SocialIcon } from "react-social-icons";
import WebIcon from "@material-ui/icons/Web";
import CategoryIcon from "@material-ui/icons/Category";
import { useProviderInfo } from "./hooks/useProviderInfo";
import { UnAuthenticatedRoutes } from "./components/UnAuthenticatedRoutes";
import { WebLink } from "./components/WebLink";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import NotInterestedIcon from "@material-ui/icons/NotInterested";

const drawerWidth = 350;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  modalBox: {
    outline: 0,
    width: "80%",
    height: "90%",
    overflow: "scroll",
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    // maxWidth: '1000px',
  },
  modalWrapper: {
    position: "absolute",
    padding: theme.spacing(1),
    overflow: "scroll",
    height: "100%",
    width: "100%",
    display: "block",
  },
  topHeading: {
    display: "flex",
    margin: theme.spacing(0.5, 0, 2, 0),
    alignItems: "center",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 9,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerContainer: {
    overflow: "auto",
    padding: theme.spacing(2),
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  providerLogo: {
    display: "block",
    maxWidth: "200px",
    height: "200px",
    width: "100%",
    margin: theme.spacing(2, "auto"),
    borderRadius: "100%",
  },
  loading: {
    padding: "2em",
    backgorund: "#fff",
    zIndex: theme.zIndex.drawer + 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    margin: "auto",
    height: "100vh",
    width: "100vw",
  },
  drawerEmail: {
    "& span": {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
}));
const getUserFromLocalStorage = () => {
  const userObject = localStorage.getItem("user");
  const token = localStorage.getItem("token");
  if (!userObject || !token) {
    return null;
  }
  const user = JSON.parse(userObject);
  return { ...user, token };
};

const getSelectedProvider = () => {
  return localStorage.getItem("selected_provider_id");
};
function App() {
  const classes = useStyles();
  const confirm = useConfirm();
  const alert = useAlert();
  const [user, setUser] = useState(getUserFromLocalStorage());
  const [adminSelectedProviderId, setAdminSelectedProviderId] = useState(
    getSelectedProvider()
  );
  const [openProviderInfo, setopenProviderInfo] = useState( 1 );
  const [branchSearchBar, setBranchSearchBar] = useState('');
  const [activitySearchBar, setActivitySearchBar] = useState('');
  const [branchID, setBranchID] = useState('');

  const [loading, setLoading] = useState(true);
  const [createModalActive, setCreateModalActive] = useState(false);
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  const [providerInfo, setProviderInfo] = useState({});
  const [activity_categoryList, setActivityCategoryList] = useState([]);
  const [activity_categoryTree, setActivityCategoryTree] = useState([]);
  const [provider_categoryList, setProviderCategoryList] = useState([]);
  const [provider_categoryTree, setProviderCategoryTree] = useState([]);
  const [providersList, setProvidersList] = useState([]);
  // const [activities, setActivities] = useState([]);
  // const [branches, setBranches] = useState([]);
  const isAdmin =
    user?.roles?.includes("ROLE_ADMIN") ||
    user?.roles?.includes("ROLE_AGENT") ||
    user?.roles?.includes("ROLE_VALIDATOR");
  const handleOpen = () => {
    setCreateModalActive(true);
  };
  const handleClose = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    setCreateModalActive(false);
  };

  useProviderInfo(user, isAdmin, setLoading, setProviderInfo);

  useEffect(() => {
    setLoading(true);
    if (!!user) {
      getCategories("Activity_category", user.token)
        .then((d) =>
          setActivityCategoryList(
            d
              .filter((e) => e.isLeaf)
              .sort((a, b) =>
                a?.vertical?.name > b?.vertical?.name
                  ? a?.parent?.name > b?.parent?.name
                    ? a.name > b.name
                      ? 1
                      : -1
                    : -1
                  : -1
              )
              .reverse()
          )
        )
        .then(() => setLoading(false));
      fetchCategoryTree("Activity_category", user.token).then((d) =>
        setActivityCategoryTree(d)
      );
      getCategories("Provider_category", user.token)
        .then((d) =>
          setProviderCategoryList(
            d
              .filter((e) => e.isLeaf)
              .sort((a, b) =>
                a?.vertical?.name > b?.vertical?.name
                  ? a?.parent?.name > b?.parent?.name
                    ? a.name > b.name
                      ? 1
                      : -1
                    : -1
                  : -1
              )
              .reverse()
          )
        )
        .then(() => setLoading(false));
      fetchCategoryTree("Provider_category", user.token).then((d) =>
        setProviderCategoryTree(d)
      );
      // getCategories('Activity_category', user.token).then(d => setActivityCategoryList(d.filter(e => e.isLeaf).sort((a,b) => (a?.name>b?.name) ? (a?.parent?.name>b?.parent?.name ? (a?.vertical?.name>b?.vertical?.name ? -1 : 1) : 1) : 1))).then(() => setLoading(false));
      // fetchCategoryTree('Activity_category', user.token).then(d => setActivityCategoryTree(d))
      // getCategories('Provider_category', user.token).then(d => setProviderCategoryList(d.filter(e => e.isLeaf).sort((a,b) => (a?.name>b?.name) ? (a?.parent?.name>b?.parent?.name ? (a?.vertical?.name>b?.vertical?.name ? -1 : 1) : 1) : 1))).then(() => setLoading(false));
      // fetchCategoryTree('Provider_category', user.token).then(d => setProviderCategoryTree(d))
      // console.log(provider_categoryList,provider_categoryTree)
    }
  }, [user]);

  const handleLogout = () => {
    setUser(null);
    setProviderInfo({});
    localStorage.clear();
  };

  const copyToClipboard = async (text) => {
    // Clipboard API not available
    if (!navigator.clipboard) {
      return;
    }
    try {
      await navigator.clipboard.writeText(text);
    } catch (err) {
      console.error("Failed to copy!", err);
    }
  };

  const handleProviderListRemove = (providerId) => {
    const updatedProvidersList = [...providersList].filter(
      (provider) => provider._id !== providerId
    );
    setProvidersList(updatedProvidersList);
    setProviderInfo({});
  };
  const handleDelete = async () => {
    try {
      await confirm({ description: "This action is permanent!" });
      console.log("Deleting providerInfo");
      setLoading(true);
      await deleteProviderInfo(providerInfo._id, user.token);
      if (!isAdmin) {
        handleLogout();
      } else {
        handleProviderListRemove(providerInfo._id);
      }
    } catch {
      console.log("delete cancelled");
    } finally {
      setLoading(false);
    }
  };

  const handleHelp = () => {};

  const handleSendActionEmail = async () => {
    try {
      await confirm({
        description: `Are you sure you want to send welcome emaill to "${providerInfo?.info?.contact?.contact_email}"`,
      });
      console.log(`sending email to ` + providerInfo._id);
      setIsSendingEmail(true);
      const res = await sendActionEmail(providerInfo._id, "", user.token);
      if (res.success) {
        alert.show("Welcome email sent", { hideIcon: true });
      } else {
        alert.show(res.message);
      }
    } catch {
      console.log("Email cancelled");
    } finally {
      console.log("Done");
      setIsSendingEmail(false);
    }
  };

  const handleValidate = (providerInfo) => () => {
    const validateText =
      "Please confirm the action, Once validated, the provider will be ready to be displayed in the app.";
    const invlidateText =
      "Please confirm the action, Once invalidated, the provider will not be accessible by the app.";
    const description = providerInfo.manual_validation_flag
      ? invlidateText
      : validateText;
    return confirm({ description })
      .then(() => {
        return validateProvider(
          providerInfo._id,
          !providerInfo.manual_validation_flag,
          user.token
        )
          .then(() => {
            setProviderInfo((prev) => ({
              ...prev,
              manual_validation_flag: !prev.manual_validation_flag,
            }));
          })
          .catch(() => {
            alert.error(
              "Something went wrong, please try again later or contact the support!"
            );
          });
      })
      .catch(() => {
        console.log("validation cancelled.");
      });
  };

  useEffect(() => {
    if (user == null) return;
    if (adminSelectedProviderId == null) return;
    setLoading(true);
    fetchProviderInfo(adminSelectedProviderId, user.token)
      .then((data) => {
        console.log(data);
        setProviderInfo(data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [adminSelectedProviderId, user]);

  const handleProviderSelect = (provider, openInfo, branchName, branchId, activityName) => {
    localStorage.setItem("selected_provider_id", provider._id);
    setAdminSelectedProviderId(provider._id);
    setopenProviderInfo(openInfo);
    setBranchSearchBar(branchName);
    setActivitySearchBar(activityName);
    setBranchID(branchId);

  };
  const onAdminClick = () => {
    localStorage.removeItem("selected_provider_id");
    setAdminSelectedProviderId(null);
    setProviderInfo({});
  };

  // If not logged in
  if (!user) {
    return <UnAuthenticatedRoutes setUser={setUser} />;
  }

  const Loading = () => {
    return (
      <Paper className={classes.loading} variant="outlined">
        <CircularProgress size={60} />
      </Paper>
    );
  };

  const MainContent = () => {
    // If admin && no providerInfo set => show list to pick
    // else show normal providerInfo

    if (isAdmin && !adminSelectedProviderId) {
      return (
        <main
          className={classes.content}
          style={{ margin: "auto", maxWidth: "100vw" }}
        >
          <Toolbar />
          <Switch>
            <Route exact path="/provider-list">
              <ProviderListPage
                providersList={providersList}
                user={user}
                onProviderListRemove={handleProviderListRemove}
                onClick={handleProviderSelect}
              />
            </Route>
            <Route exact path="/create-provider">
              <AdminCreateProvider
                categoryList={provider_categoryList}
                providerCategoryTree={provider_categoryTree}
                onUpdate={setProvidersList}
                user={user}
              />
            </Route>
            <Route exact path="/help">
              <HelpPage />
            </Route>
            <Redirect to="/provider-list" />
          </Switch>
        </main>
      );
    }
    return (
      <main className={classes.content}>
        <Toolbar />
        {!!providerInfo._id ? (
          <NavigationComponent isDisabled={!providerInfo._id} />
        ) : null}
        <div>
          <Switch>
            <Route exact path="/">
              { openProviderInfo === 1 ? <Redirect to="/provider-info" /> : openProviderInfo === 2?  <Redirect to="/branches" /> : 
              <Redirect to="/activities" />}
            </Route>
            <Route path="/branches">
              <BranchesPage
                branches={providerInfo.branches}
                user={user}
                providerId={providerInfo._id}
                handleUpdate={setProviderInfo}
                branchSearchBar={branchSearchBar}
              />
            </Route>
            <Route path="/activities">
              <ActivitiesPage
                activities={providerInfo.activities}
                providerId={providerInfo._id}
                providerCategory={providerInfo.info?.category}
                categoryList={activity_categoryList}
                categoryTree={activity_categoryTree}
                providerCategoryList={provider_categoryList}
                providerCategoryTree={provider_categoryTree}
                handleUpdate={setProviderInfo}
                branches={providerInfo?.branches || []}
                user={user}
                activitySearchBar={activitySearchBar}
                branchID={branchID}
              />
            </Route>
            <Route exact path="/provider-info">
              <OverviewPage
                providerId={providerInfo._id}
                handleClose={handleClose}
                handleOpen={handleOpen}
                user={user}
                createModalActive={createModalActive}
                onProviderInfoUpdate={setProviderInfo}
              />
            </Route>
            <Redirect to="/" />
          </Switch>
        </div>
      </main>
    );
  };

  return (
    <Router>
      <div style={{ display: "flex", overflow: "hidden" }}>
        {loading && <Loading />}
        <HeaderBar
          onLogout={handleLogout}
          onAdminClick={onAdminClick}
          user={user}
          isAdmin={isAdmin}
          hasData={!!providerInfo._id}
          onDelete={handleDelete}
          onHelp={handleHelp}
        />
        <Drawer
          className={classes.drawer}
          variant={!providerInfo._id ? "temporary" : "permanent"}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <Toolbar />
          <div className={classes.drawerContainer}>
            <img
              src={providerInfo?.info?.logo_url}
              alt="Logo of provider"
              className={classes.providerLogo}
            />
            <div style={{ display: "flex", marginBottom: "8px" }}>
              <Typography component="h5" variant="h5" style={{ flex: 1 }}>
                {providerInfo?.info?.name}
              </Typography>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleOpen}
                startIcon={<Edit />}
                disableElevation
                size="small"
              >
                Edit
              </Button>
            </div>
            <Typography variant="subtitle1" color="textSecondary">
              {providerInfo?.info?.description}
            </Typography>
            <List>
              {isAdmin && (
                <ListItem>
                  <ListItemIcon>
                    <Label />
                  </ListItemIcon>
                  <Tooltip
                    title="Click to copy"
                    style={{ cursor: "pointer" }}
                    onClick={() => copyToClipboard(providerInfo._id)}
                    arrow
                  >
                    <ListItemText className={classes.drawerEmail}>
                      {providerInfo._id}
                    </ListItemText>
                  </Tooltip>
                </ListItem>
              )}
              <ListItem>
                <ListItemIcon>
                  <Phone />
                </ListItemIcon>
                <ListItemText>
                  {providerInfo?.info?.contact?.contact_phone_number !== ""
                    ? "+ " + providerInfo?.info?.contact?.contact_phone_number
                    : ""}
                </ListItemText>
              </ListItem>
              {isAdmin && (
                <ListItem>
                  <ListItemIcon>
                    <EmailIcon />
                  </ListItemIcon>
                  <Tooltip
                    title={providerInfo?.info?.contact?.contact_email}
                    placement="top"
                    arrow
                  >
                    <ListItemText className={classes.drawerEmail}>
                      {providerInfo?.info?.contact?.contact_email}
                    </ListItemText>
                  </Tooltip>
                </ListItem>
              )}
              <ListItem>
                <ListItemIcon>
                  <CategoryIcon style={{ fontSize: 25 }} />
                </ListItemIcon>
                <ListItemText>
                  {providerInfo?.info?.category?.name}
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <Place />
                </ListItemIcon>
                <ListItemText>
                  {[
                    providerInfo?.info?.address?.address_line_1,
                    providerInfo?.info?.address?.street,
                    providerInfo?.info?.address?.landmark,
                    providerInfo?.info?.address?.city,
                    providerInfo?.info?.address?.state,
                    providerInfo?.info?.address?.country,
                    providerInfo?.info?.address?.zipCode,
                  ]
                    .filter((e) => !!e)
                    .map(
                      (text, i) =>
                        !!text && (
                          <Fragment key={text}>
                            {!!i && <br />}
                            {text}
                          </Fragment>
                        )
                    )}
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <Note />
                </ListItemIcon>
                <ListItemText>{providerInfo?.info?.license}</ListItemText>
              </ListItem>
              {!!providerInfo?.info?.license_expiry_date && (
                <ListItem>
                  <ListItemIcon>
                    <Today />
                  </ListItemIcon>
                  <ListItemText>
                    {format(
                      new Date(
                        providerInfo?.info?.license_expiry_date?.toString()
                      ),
                      "P"
                    )}
                  </ListItemText>
                </ListItem>
              )}
              {Object.entries(providerInfo?.info?.weblinks || {}).map(
                ([type, text]) => (
                  <WebLink text={text} iconType={type} />
                )
              )}
              <ListItem>
                <ListItemText>
                  {user?.roles?.includes("ROLE_VALIDATOR") ||
                    (user?.roles?.includes("ROLE_ADMIN") && (
                      <Button
                        variant="contained"
                        color="secondary"
                        disableElevation
                        style={{
                          width: "100%",
                        }}
                        className={
                          providerInfo.manual_validation_flag
                            ? classes.validatedButton
                            : ""
                        }
                        startIcon={
                          providerInfo.manual_validation_flag ? (
                            <NotInterestedIcon />
                          ) : (
                            <ThumbUpIcon />
                          )
                        }
                        onClick={handleValidate(providerInfo)}
                      >
                        {providerInfo.manual_validation_flag
                          ? "Invalidate"
                          : "Validate"}
                      </Button>
                    ))}
                </ListItemText>
              </ListItem>

              {isAdmin && (
                <>
                  <ListItem>
                    <ListItemText>
                      <Button
                        variant="contained"
                        style={{
                          width: "100%",
                          backgroundColor: isSendingEmail ? "#666" : "#f50057",
                        }}
                        onClick={handleSendActionEmail}
                        disabled={isSendingEmail}
                        color="secondary"
                        disableElevation
                      >
                        {isSendingEmail ? (
                          <CircularProgress
                            color="inherit"
                            style={{ marginRight: 8 }}
                            size={20}
                          />
                        ) : (
                          <Send style={{ marginRight: 8 }} />
                        )}
                        Send welcome email
                      </Button>
                    </ListItemText>
                  </ListItem>
                  {/*
                                        <ListItem>
                                            <ListItemText>
                                                <Button variant="contained"
                                                    style={{width: '100%', backgroundColor: isSendingEmail ? '#666' : '#f50057'}}
                                                    onClick={handleSendActionEmail}
                                                    color="secondary" disableElevation>
                                                    <Send style={{marginRight: 8}} />
                                                    Send Action email
                                                </Button>
                                            </ListItemText>
                                        </ListItem>
                                            */}
                </>
              )}
            </List>
          </div>
        </Drawer>

        <MainContent />

        <Modal
          open={createModalActive}
          className={classes.modalWrapper}
          onClose={handleClose}
        >
          <Box className={classes.modalBox}>
            <AddProviderInfo
              categoryList={provider_categoryList}
              categoryTree={provider_categoryTree}
              providerInfo={providerInfo}
              onUpdate={setProviderInfo}
              user={user}
              isAdmin={isAdmin}
              onCancel={handleClose}
            />
          </Box>
        </Modal>
      </div>
    </Router>
  );
}

export default App;
